import React from 'react';
import { WebsiteImage } from 'components/TitleDescription';
import CardsBodyWrapper from '../CardsBodyWrapper';
import { ImageContainer, QuoteContainer, FooterAuthorContainer } from './styles';

const ReviewCard = props => {
  const { quote, author, company, companyLogo } = props;
  return (
    <div
      data-testid="card-body-wrapper"
      role="listitem"
      className={`card--body-wrapper ${author || company ? 'with-footer-author' : ''}`}
    >
      {companyLogo && (
        <ImageContainer>
          <WebsiteImage src={companyLogo.fluid || companyLogo.file.url} alt={company} />
        </ImageContainer>
      )}
      {quote && (
        <QuoteContainer className="description-color">
          <p>“{quote}”</p>
        </QuoteContainer>
      )}
      {(author || company) && <FooterAuthor author={author} company={company} />}
    </div>
  );
};

export default CardsBodyWrapper(ReviewCard);

const FooterAuthor = ({ author, company }) => {
  return (
    <FooterAuthorContainer>
      {author && <p className="footer-author--author">{author}</p>}
      {company && <p className="footer-author--company">{company}</p>}
    </FooterAuthorContainer>
  );
};
